import React from "react";
import QuoteTemplateRenderer from "./QuoteTemplates";

function NoEventsPage(props) {
  return <QuoteTemplateRenderer templateKey="template1" {...props} />;
}

export default NoEventsPage;
